import type { ActiveShoppingCart } from '../types';

export function activeCartSnapshotKey(cart: ActiveShoppingCart | null | undefined): string {
    if (!cart) return '';
    const orderKey = (cart.collectionOrder ?? []).join('|');
    const itemsKey = [...(cart.items ?? [])]
        .sort((a, b) => a.id.localeCompare(b.id))
        .map((item) => {
            const qty = item.sources.reduce((sum, source) => sum + source.quantity, 0);
            return `${item.id}:${item.done ? 1 : 0}:${item.unit}:${item.category ?? ''}:${qty.toFixed(3)}`;
        })
        .join('|');
    return `${orderKey}::${itemsKey}`;
}

export function swapVisiblePillarsInOrder(
    order: readonly string[],
    visiblePillarIds: readonly string[],
    pillarId: string,
    direction: 'up' | 'down',
): string[] {
    const visibleIndex = visiblePillarIds.indexOf(pillarId);
    if (visibleIndex === -1) return [...order];

    const swapVisibleIndex = direction === 'up' ? visibleIndex - 1 : visibleIndex + 1;
    if (swapVisibleIndex < 0 || swapVisibleIndex >= visiblePillarIds.length) {
        return [...order];
    }

    const otherId = visiblePillarIds[swapVisibleIndex];
    const pillarIndex = order.indexOf(pillarId);
    const otherIndex = order.indexOf(otherId);
    if (pillarIndex === -1 || otherIndex === -1) return [...order];

    const nextOrder = [...order];
    [nextOrder[pillarIndex], nextOrder[otherIndex]] = [nextOrder[otherIndex], nextOrder[pillarIndex]];
    return nextOrder;
}
